<style>
.price-inside-prod .content-box {
  padding: 0px !important;
  margin: 0px !important;
}
.price-inside-prod .todo-content {
  padding: 0px !important;
  margin: 0px !important;
}
.price-inside-prod .all-tasks-w {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>
<template>
  <div class="todo-app-w" :class="{ 'price-inside-prod': sku_p != null }">
    <div class="col-12 content-box">
      <div class="row">
        <div class="col-sm-12">
          <div class>
            <h6 class="element-header">
              Producto: {{ current.sku }} - {{ current.nombre }}
            </h6>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="element-wrapper">
            <div class="todo-content">
              <h4 class="todo-content-header">
                <i class="os-icon os-icon-ui-83"></i>
                <span>{{ current.sku }} - {{ current.nombre }}</span>
              </h4>
              <div
                class="status-pill green"
                data-title="Activo"
                data-toggle="tooltip"
                data-original-title
                title
              ></div>
              <span>Precios Activos</span>&nbsp;
              <br />
              <div
                class="status-pill red"
                data-title="Activo"
                data-toggle="tooltip"
                data-original-title
                title
              ></div>
              <span>Precios Inactivos</span>

              <br />

              <router-link
                class="btn btn-success"
                :to="{
                  name: 'cat-productos-precios-v2',
                  params: {},
                }"
              >
                <i class="fas fa-cash-register"></i>&nbsp;
                <span>Análisis de Precios</span>
              </router-link>
              <router-link
                class="btn btn-success"
                :to="{
                  name: 'compras-lista-precios-compras',
                  params: {},
                }"
              >
                <i class="fa fa-dollar-sign"></i>&nbsp;
                <span>Ir a precios de compras</span>
              </router-link>
              <br />
              <div class="all-tasks-w">
                <div
                  class="tasks-section"
                  v-for="l_precio in listas_de_precios"
                  :key="l_precio.pk"
                >
                  <!--START - TASKS HEADER-->
                  <div class="tasks-header-w">
                    <a
                      type="button"
                      class="tasks-header-toggler"
                      @click="toggleSection"
                    >
                      <i class="os-icon os-icon-ui-23"></i>
                    </a>
                    <h5 class="tasks-header">{{ l_precio.nombre }}</h5>
                    <span class="tasks-sub-header" v-if="l_precio.estatus"
                      >Activa</span
                    >
                    <span class="tasks-sub-header" v-if="!l_precio.estatus"
                      >Inactiva</span
                    >
                    <a
                      class="add-task-btn"
                      data-target="#modalAddProductoPrecio"
                      data-toggle="modal"
                      href="#"
                      @click="showModal(l_precio)"
                    >
                      <i class="os-icon os-icon-ui-22"></i>
                      <span>Agregar Precio</span>
                    </a>
                  </div>
                  <!--END - TASKS HEADER-->
                  <div class="tasks-list-w">
                    <div class="table-responsive">
                      <table class="table table-lightborder">
                        <thead>
                          <tr>
                            <th>Unidad Medida</th>
                            <th class="text-center">Fecha Inicio</th>
                            <th class="text-center">Fecha Fin</th>
                            <th class="text-right">Costo</th>
                            <th class="text-right">Otros</th>
                            <th class="text-center">Tipo Calculo</th>
                            <th class="text-center">Margen</th>
                            <th class="text-right">Precio</th>
                            <th class="text-right" style="width: 10px"></th>
                            <th class="text-right" style="width: 100px"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="precio in getListaPrecio(l_precio, true)"
                            :key="precio.id"
                          >
                            <td class="nowrap">
                              {{ precio.unidad_medida.nombre }}
                            </td>
                            <td class="text-right">
                              {{ precio.valido_desde }}
                            </td>
                            <td class="text-right">
                              {{ precio.valido_hasta }}
                            </td>
                            <td class="text-right">{{ precio.costo }}</td>
                            <td class="text-right">
                              {{ precio.otros_costos }}
                            </td>
                            <td class="text-center">
                              {{ precio.tipo_calculo }}
                            </td>
                            <td class="text-center">
                              <span v-if="precio.tipo_calculo == 'FIJO'"
                                >Q</span
                              >
                              {{ precio.margen }}
                              <span v-if="precio.tipo_calculo == 'PORC'"
                                >%</span
                              >
                            </td>
                            <td class="text-right">{{ precio.precio }}</td>
                            <td class="text-right">
                              <div
                                v-if="precio.estatus"
                                class="status-pill green"
                                data-title="Activo"
                                data-toggle="tooltip"
                                data-original-title
                                title
                              ></div>
                              <div
                                v-if="!precio.estatus"
                                class="status-pill red"
                                data-title="Activo"
                                data-toggle="tooltip"
                                data-original-title
                                title
                              ></div>
                            </td>
                            <td class="text-right">
                              <a
                                data-target="#modal-historial"
                                data-toggle="modal"
                                href="#"
                                @click="verHistorialDePrecio(precio)"
                                class="btn btn-sm btn-info"
                              >
                                <i class="fa fa-history"></i>&nbsp;
                                <span>Detalle</span>
                              </a>
                            </td>
                          </tr>
                          <tr
                            v-for="precio in getListaPrecio(l_precio, false)"
                            :key="precio.id"
                          >
                            <td class="nowrap">
                              {{ precio.unidad_medida.nombre }}
                            </td>
                            <td class="text-right">
                              {{ precio.valido_desde }}
                            </td>
                            <td class="text-right">
                              {{ precio.valido_hasta }}
                            </td>
                            <td class="text-right">{{ precio.costo }}</td>
                            <td class="text-right">
                              {{ precio.otros_costos }}
                            </td>
                            <td class="text-center">
                              {{ precio.tipo_calculo }}
                            </td>
                            <td class="text-center">
                              <span v-if="precio.tipo_calculo == 'FIJO'"
                                >Q</span
                              >
                              {{ precio.margen }}
                              <span v-if="precio.tipo_calculo == 'PORC'"
                                >%</span
                              >
                            </td>
                            <td class="text-right">{{ precio.precio }}</td>
                            <td class="text-right">
                              <div
                                v-if="precio.estatus"
                                class="status-pill green"
                                data-title="Activo"
                                data-toggle="tooltip"
                                data-original-title
                                title
                              ></div>
                              <div
                                v-if="!precio.estatus"
                                class="status-pill red"
                                data-title="Activo"
                                data-toggle="tooltip"
                                data-original-title
                                title
                              ></div>
                            </td>
                            <td class="text-right">
                              <a
                                data-target="#modal-historial"
                                data-toggle="modal"
                                href="#"
                                @click="verHistorialDePrecio(precio)"
                                class="btn btn-sm btn-info"
                              >
                                <i class="fa fa-history"></i>&nbsp;
                                <span>Detalle</span>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!--END - Tasks List-->
              </div>
              <router-link
                :to="{
                  name: 'cat-productos-editar',
                  params: { sku: current.sku },
                }"
              >
                <h5 style="color: green">
                  <i class="fas fa-reply-all"></i> Regresar a Producto
                </h5>
              </router-link>
              <div v-if="agregar">
                <AgregarPrecioModalComponent
                  v-if="current.sku != null && lista_precio_actual != null"
                  :lista_precio="lista_precio_actual"
                  :producto="current"
                  @cerrandomodal="refreshProducto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Modal - Edit Task-->
    <div
      aria-hidden="true"
      class="modal fade"
      id="modal-historial"
      role="dialog"
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-lg"
        role="document"
        v-if="precio_actual != null"
      >
        <div class="modal-content" style="width: 100%; max-width: 100%">
          <div class="modal-header faded smaller">
            <div class="modal-title">
              <span>Sku: {{ current.sku }}</span>
              <span>Producto:</span>
              <strong>{{ current.nombre }}</strong>
            </div>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-title">
              <span
                >Lista de Precio: {{ precio_actual.lista_precio.nombre }}</span
              >&nbsp;
              <span>Unidad Medida:</span>
              <strong>{{ precio_actual.unidad_medida.nombre }}</strong>
            </div>
            <br />
            <table class="table table-compact">
              <thead>
                <tr>
                  <th>Rangos de Fechas</th>
                  <th class="text-right">Calculo</th>
                  <th class="text-right">Margen</th>
                  <th class="text-right">Costo</th>
                  <th class="text-right">Precio Venta</th>
                  <th class="text-center">Modificacion</th>
                  <th class="text-center">Usuario Modifico</th>
                  <th class="text-center"></th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="_hist in historial">
                  <td>
                    <span>{{ _hist.valido_desde }}</span>
                    <i class="os-icon os-icon-repeat icon-separator"></i>
                    <span>{{ _hist.valido_hasta }}</span>
                  </td>
                  <td class="text-right text-bright">
                    {{ _hist.tipo_calculo }}
                  </td>
                  <td class="text-right text-bright">
                    <span v-if="_hist.tipo_calculo == 'FIJO'">Q</span>
                    {{ _hist.margen }}
                    <span v-if="_hist.tipo_calculo == 'PORC'">%</span>
                  </td>
                  <td class="text-right text-bright">Q {{ _hist.costo }}</td>
                  <td
                    class="text-right"
                    :class="{ 'text-success': _hist.precio > _hist.costo }"
                  >
                    Q {{ _hist.precio }}
                  </td>
                  <td class="text-right">
                    {{ _hist.fecha_modificacion }}
                  </td>
                  <td class="text-right">
                    <UsuarioEnTablaComponent
                      v-if="_hist.usuario_modificacion"
                      :current="_hist.usuario_modificacion"
                    />
                  </td>
                  <td>
                    <div
                      v-if="_hist.estatus"
                      class="status-pill green"
                      data-title="Activo"
                      data-toggle="tooltip"
                      data-original-title
                      title
                    ></div>
                    <div
                      v-if="!_hist.estatus"
                      class="status-pill red"
                      data-title="Activo"
                      data-toggle="tooltip"
                      data-original-title
                      title
                    ></div>
                  </td>
                  <td>
                    <button
                      v-if="_hist.estatus"
                      @click="cambiarEstatus(_hist)"
                      type="button"
                      class="btn btn-sm btn-warning"
                    >
                      Inactivar
                    </button>
                    <button
                      v-if="!_hist.estatus"
                      @click="cambiarEstatus(_hist)"
                      type="button"
                      class="btn btn-sm btn-success"
                    >
                      Activar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer buttons-on-left">
            <button class="btn btn-link" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import ProductosService from "@/services/catalogos/ProductosService";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import ProductosTiendaService from "@/services/catalogos/ProductosTiendaService";
import Notifications from "@/notifications/notifications";
import AgregarPrecioModalComponent from "@/components/cat/productos/AgregarPrecioModalComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    AgregarPrecioModalComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      editando: false,
      sku: null,
      agregar: false,
      listas_de_precios: [],
      lista_precio_actual: null,
      current: {
        pk: null,
        errors: {},
        precios: [],
      },
      historial: [],
      precio_actual: null,
    };
  },
  props: ["sku_p"],
  computed: {},
  mounted() {
    let self = this;
    self.refreshListasDePrecios();
    if (self.$route.params.sku) {
      self.sku = self.$route.params.sku;
    }
    if (self.sku_p) {
      self.sku = self.sku_p;
    }
    self.refreshProducto();
    this.refreshUm();
  },
  methods: {
    refreshUm() {
      let self = this;
      let p = {
        activa: true,
        quitar_paginacion: true,
      };
      if (self.sku) {
        p.producto = self.sku;
      }
      this.$store.dispatch("catalogos/unidades_medidas", p);
    },
    getListaPrecio(lp, activos) {
      let self = this;
      var d = [];
      if (!self.current.productounidadmedida_set) {
        return d;
      }
      self.current.productounidadmedida_set.forEach(function (um) {
        var agregado = false;

        self.current.lista_precios.forEach(function (item, index) {
          if (
            item.unidad_medida.id == um.unidad_medida.id &&
            item.lista_precio.id == lp.id
          ) {
            if (activos) {
              d.push(item);
            }
            agregado = true;
          }
        });

        if (activos == false) {
          if (!agregado) {
            d.push({
              lista_precio: lp,
              unidad_medida: um.unidad_medida,
              costo: "-",
              valido_desde: null,
              valido_hasta: null,
              tipo_calculo: "",
              margen: "0.00",
              precio: "0.00",
              estatus: false,
              producto: self.producto,
            });
          }
        }
      });
      return d;
    },
    refreshProducto() {
      let self = this;
      self.agregar = false;
      ProductosService.getById(self.sku).then((response) => {
        self.current = response.data;
        self.current.errors = [];
        self.current.pk = self.current.sku;
      });
    },
    refreshListasDePrecios() {
      let self = this;
      ListaPreciosService.fetch({
        quitar_paginacion: true,
      }).then((response) => {
        self.listas_de_precios = response.data;
      });
    },
    toggleSection(event) {
      $(event.target)
        .closest(".tasks-section")
        .find(".tasks-list-w")
        .slideToggle(100);
    },
    refreshHistorial() {
      let self = this;
      ProductosService.precios({
        producto: self.current.sku,
        lista_precio: self.precio_actual.lista_precio.id,
        unidad_medida: self.precio_actual.unidad_medida.id,
        quitar_paginacion: true,
        historial: true,
      }).then((response) => {
        self.historial = response.data;
      });
    },
    verHistorialDePrecio(precio) {
      let self = this;
      self.precio_actual = precio;
      self.refreshHistorial();
      $("#modal-historial").show();
    },
    cambiarEstatus(c) {
      let self = this;
      ProductosService.cambiar_estatus_a_precio(c.id).then((response) => {
        self.refreshHistorial();
        self.refreshProducto();
      });
    },
    showModal(l_precio) {
      let self = this;
      self.refreshUm();
      self.lista_precio_actual = l_precio;
      self.agregar = true;
    },
  },
};
</script>
